export default __webpack_public_path__ + "static/Social-media-722d9b4219959fdd8f03aec58e82f775.webp";